import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getActiveStudent } from 'helpers/guardian';
import { addError } from 'actions';
import { getNotifications } from 'actions/notifications';
import { setActiveStudent, setActiveSchool } from 'actions/user';
import { translate } from '@haldor/ui';
var NotificationReceiver = /*#__PURE__*/function (_Component) {
  function NotificationReceiver(props) {
    var _this;
    _classCallCheck(this, NotificationReceiver);
    _this = _callSuper(this, NotificationReceiver, [props]);
    _defineProperty(_this, "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var translate, student;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            translate = _this.props.translate;
            if (!(_this.getParameterByName('studentId') == null || _this.getParameterByName('studentId') == 'null')) {
              _context.next = 7;
              break;
            }
            if (!(_this.getParameterByName('url') != null)) {
              _context.next = 5;
              break;
            }
            _this.props.history.push(_this.getParameterByName('url'));
            return _context.abrupt("return", true);
          case 5:
            _this.props.history.push('/');
            return _context.abrupt("return", true);
          case 7:
            if (!(getActiveStudent() != _this.getParameterByName('studentId'))) {
              _context.next = 17;
              break;
            }
            student = _this.props.students.find(function (student) {
              return student.id == _this.getParameterByName('studentId');
            });
            if (!(student != null)) {
              _context.next = 17;
              break;
            }
            _context.next = 12;
            return _this.props.setActiveStudent(student);
          case 12:
            if (!(student.schools != null && student.schools.length > 0)) {
              _context.next = 15;
              break;
            }
            _context.next = 15;
            return _this.props.setActiveSchool(student.schools[0].id, student.id);
          case 15:
            _context.next = 17;
            return _this.props.addError("".concat(translate('Changed child to'), ": ").concat(student.firstName, " ").concat(student.lastName), 'info');
          case 17:
            _this.props.history.push(_this.getParameterByName('url'));
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _inherits(NotificationReceiver, _Component);
  return _createClass(NotificationReceiver, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    students: state.guardians.students
  };
}
export default withRouter(connect(mapStateToProps, {
  addError: addError,
  getNotifications: getNotifications,
  setActiveStudent: setActiveStudent,
  setActiveSchool: setActiveSchool
})(NotificationReceiver));